'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AllIcons;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('./index');

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function AllIcons(props) {
    var iconType = props.iconType,
        rest = _objectWithoutProperties(props, ['iconType']);

    var icons = (0, _map2.default)(_index.LABELS, function (label) {
        return _react2.default.createElement((0, _index.getIcon)(iconType, label), _extends({}, rest, { key: label }));
    });

    return _react2.default.createElement(
        'div',
        null,
        icons
    );
}

AllIcons.displayName = 'AllIcons';
AllIcons.propTypes = {
    iconType: _propTypes2.default.string
};
AllIcons.defaultProps = {
    iconType: 'full'
};